import { render, staticRenderFns } from "./SimpleTableComponent.vue?vue&type=template&id=7d8fb2ed"
import script from "./SimpleTableComponent.vue?vue&type=script&lang=js"
export * from "./SimpleTableComponent.vue?vue&type=script&lang=js"
import style0 from "./SimpleTableComponent.vue?vue&type=style&index=0&id=7d8fb2ed&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports